module.exports = __webpack_public_path__ + "static/media/background_onboarding.0f559399.png";